<template>
  <!-- { error: !colorName && validate.indexOf('color') != -1 }, -->
  <div class="form-container">
    <div
      class="material-box"
      v-for="(order, orderIndex) in formList"
      :key="orderIndex"
    >
      <span
        class="iconfont icon-close"
        @click="handleDeleteOrder(orderIndex)"
      ></span>
      <div class="cell no-boder">
        <div class="name"><span>*</span>选择材质</div>
        <div
          class="choose"
          @click="checkMaterial(orderIndex)"
          :class="[
            { color: order.packMaterial },
            { active: prfTLookDecide },
            { error: isError && !order.packMaterial },
          ]"
        >
          {{
            order.packMaterial
              ? order.packMaterial === 1
                ? "六面泡沫包装"
                : order.packMaterial === 2
                ? "蜂窝包装"
                : order.packMaterial === 2
                ? "蜂窝包装+FSC"
                : ""
              : "请选择"
          }}
          <i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
        </div>
      </div>
      <div class="cell top">
        <div class="name">颜色</div>
        <div class="choose button" @click="handleAddColor(orderIndex)">
          添加颜色
        </div>
      </div>
      <div class="list">
        <div
          class="color-box"
          v-for="(country, countryKey) in order.countryList"
          :key="countryKey"
        >
          <span
            class="iconfont icon-close"
            @click="handleDeleteColor(orderIndex, countryKey)"
          ></span>
          <div class="color-header">
            <div class="left">
              <span class="round"></span>
              <span class="text"
                >{{ country.colorAskName }}(总计{{
                  getAllNumber(country)
                }}件)</span
              >
            </div>
            <i
              class="iconfont icon-tianjia"
              v-if="getCountryNum() > country.codes.length"
              @click="handleChooseStash(orderIndex, countryKey)"
            ></i>
          </div>
          <div
            class="item"
            v-for="(code, codeKey) in country.codes"
            :key="codeKey"
            @click="handleChooseStash(orderIndex, countryKey, codeKey)"
          >
            <div class="item-left">
              <div class="row">
                <div class="line">
                  <div class="label">仓库：</div>
                  <div class="value">{{ code.code }}</div>
                </div>
                <div class="line">
                  <div class="label">数量：</div>
                  <div class="value">{{ code.goodSum }}件</div>
                </div>
              </div>
              <div class="row">
                <div class="line">
                  <div class="label">开船时间：</div>
                  <div class="value">
                    {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="item-right">
              <i class="iconfont icon-a-xialakaobei"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <van-popup v-model="colorPicker" round position="bottom">
      <van-picker
        :title="'颜色要求'"
        show-toolbar
        :columns="activeColorList"
        @cancel="colorPicker = false"
        @confirm="colorConfirm"
        value-key="dictLabel"
      />
    </van-popup>
    <van-popup v-model="materialPicker" round position="bottom">
      <van-picker
        :title="'包装材质'"
        show-toolbar
        :columns="activeMaterialList"
        @cancel="materialPicker = false"
        @confirm="materialConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { sampleApi } from '../api/lookApi/api'

const pageApi = new sampleApi();

export default {
  name: "ViewingSamplePhoneOrderForm",
  props: {
    colorList: {
      default: [],
    },
    prfTLookDecide: {},
    orderList: {},
    countryName: {}
  },
  data() {
    return {
      colorPicker: false,
      formList: [],
      colorName: "",
      formItem: {
        countryList: [],
        packMaterial: null,
      },
      rowItem: {},
      rowCode: {},
      isAdd: true,
      isError: false,
      rowCodeIndex: 0,
      activeColorList: [],
      activeMaterialList: [],
      materialPicker: false,
      materialRowItem: null,
      materialList: [
        {
          text: "六面泡沫包装",
          value: 1,
        },
        {
          text: "蜂窝包装",
          value: 2,
        },
        {
          text: "蜂窝包装+FSC",
          value: 3,
        },
      ],
      colorRowItem: null,
      warehouseRowItem: null,
      countryList: []
    };
  },
  watch: {
    orderList(val) {
      this.handleInit(val);
    },
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    async getCountryList() {
      const list = await pageApi.getStashList();
      this.countryList = list;
    },
    getCountryNum() {
      let num = 0;
      for (let i = 0; i < this.countryList.length; i++) {
        if (this.countryList[i].countryTypeName ===  this.countryName) {
          num = this.countryList[i].codeList.length;
        }
      }
      return num;
    },
    handleInit(val) {
      if (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].countryList.forEach((item) => {
            item.codes.forEach((code) => {
              code.countryId = item.countryId;
            })
          })
        }
        this.formList = JSON.parse(JSON.stringify(val));
      }
    },
    delOrder(orderIndex) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认删除该颜色?",
        confirmButtonColor: "#3F996C",
      })
        .then(() => {
          this.formList.splice(orderIndex, 1);
        })
        .catch(() => {});
    },
    stashDel() {
      let { index, index2, index3 } = this.warehouseRowItem;
      if (index3 >= 0) {
        this.formList[index].countryList[index2].codes.splice(index3, 1);
      }
      // if (this.rowCodeIndex) {
      //   this.rowItem.codes.splice(this.rowCodeIndex, 1);
      // }
      // this.$nextTick(() => {
      //   this.setStash({});
      // });
    },
    handleAddColor(index) {
      this.colorPicker = true;
      let list = [];
      let colorList = [];
      this.formList[index].countryList.forEach((order) => {
        if (order.colorAsk) {
          list.push(order.colorAsk);
        }
      });

      colorList = this.colorList.filter((color) => {
        return list.indexOf(color.dictValue) == -1;
      });
      this.activeColorList = JSON.parse(JSON.stringify(colorList));
      this.colorPicker = true;
      this.colorRowItem = index;
    },
    checkColor(item) {
      if (!this.prfTLookDecide) {
        let list = [],
          colorList = [];
        this.formList.forEach((order) => {
          if (order.colorAsk && order.colorAsk != item.colorAsk) {
            list.push(order.colorAsk);
          }
        });
        colorList = this.colorList.filter((color) => {
          return list.indexOf(color.dictValue) == -1;
        });
        this.activeColorList = JSON.parse(JSON.stringify(colorList));
        this.colorPicker = true;
        this.rowItem = item;
      }
    },
    checkMaterial(index) {
      this.materialPicker = true;
      let packMaterial = this.formList[index].packMaterial;
      let cList = [];
      this.formList.forEach((item) => {
        if (item.packMaterial && item.packMaterial != packMaterial) {
          cList.push(item.packMaterial);
        }
      });

      this.activeMaterialList = this.materialList.filter((item) => {
        return cList.indexOf(item.value) === -1;
      });
      this.materialRowItem = index;
    },
    materialConfirm(val) {
      this.materialPicker = false;
      this.formList[this.materialRowItem].packMaterial = val.value;
    },
    colorConfirm(val) {
      this.formList[this.colorRowItem].countryList.push({
        codes: [],
        colorAsk: val.dictValue,
        colorAskName: val.dictLabel,
      });
      this.colorPicker = false;
      // this.rowItem.colorAskName = val.dictLabel;
      // this.rowItem.colorAsk = val.dictValue;
      // this.colorPicker = false;
    },
    handleStash(query) {
      const { codeId, countryId, goodSum, shipTime, stashName } = query;
      if (this.isAdd) {
        this.formList[this.warehouseRowItem.index].countryList[
          this.warehouseRowItem.index2
        ].codes.push({
          code: stashName,
          codeId,
          goodSum,
          shipTime,
          countryId
        });
        // this.formList[this.warehouseRowItem.index].countryList[
        //   this.warehouseRowItem.index2
        // ].countryId = countryId;
      } else {
        this.formList[this.warehouseRowItem.index].countryList[
          this.warehouseRowItem.index2
        ].codes[this.warehouseRowItem.index3].code = stashName;
        this.formList[this.warehouseRowItem.index].countryList[
          this.warehouseRowItem.index2
        ].codes[this.warehouseRowItem.index3].codeId = codeId;
        this.formList[this.warehouseRowItem.index].countryList[
          this.warehouseRowItem.index2
        ].codes[this.warehouseRowItem.index3].goodSum = goodSum;
        this.formList[this.warehouseRowItem.index].countryList[
          this.warehouseRowItem.index2
        ].codes[this.warehouseRowItem.index3].shipTime = shipTime;
      }
      // if (this.isAdd) {
      //   this.rowItem.codes.push({ code: stashName, codeId, goodSum, shipTime });
      //   this.rowItem.countryId = countryId;
      // } else {
      //   this.rowCode.code = stashName;
      //   this.rowCode.codeId = codeId;
      //   this.rowCode.goodSum = goodSum;
      //   this.rowCode.shipTime = shipTime;
      // }
      // this.$nextTick(() => {
      //   this.setStash({});
      // });
    },
    handleChooseStash(index, index2, index3) {
      let itemCodes = this.formList[index].countryList[index2].codes;
      let codes = [];
      this.warehouseRowItem = {
        index,
        index2,
        index3,
      };
      if (index3 === undefined) {
        itemCodes.forEach((item) => {
          codes.push(item.codeId);
        });
        this.isAdd = true;
        this.$router.push({
          path: "choose-stash",
          query: {
            proofId: this.$route.query.proofId,
            userId: this.$route.query.userId,
            type: "advice",
            codes: JSON.stringify(codes),
            countryTypeName: this.countryName
          },
        });
      } else {
        let code = this.formList[index].countryList[index2].codes[index3];

        itemCodes.forEach((item) => {
          if (!code || item.codeId != code.codeId) codes.push(item.codeId);
        });
        this.isAdd = false;
        this.$router.push({
          path: "choose-stash",
          query: {
            proofId: this.$route.query.proofId,
            userId: this.$route.query.userId,
            code: JSON.stringify(code),
            length: itemCodes.length,
            type: "advice",
            codes: JSON.stringify(codes),
          },
        });
      }
    },
    chooseStash(order, code, index) {
      let codes = [];
      order.codes.forEach((item) => {
        if (!code || item.codeId != code.codeId) codes.push(item.codeId);
      });

      if (!code) {
        this.rowItem = order;
        this.$router.push({
          path: "choose-stash",
          query: {
            proofId: this.$route.query.proofId,
            userId: this.$route.query.userId,
            type: "advice",
            codes: JSON.stringify(codes),
          },
        });
        this.isAdd = true;
      } else {
        this.rowItem = order;
        this.rowCode = code;
        this.$router.push({
          path: "choose-stash",
          query: {
            proofId: this.$route.query.proofId,
            userId: this.$route.query.userId,
            code: JSON.stringify(code),
            length: order.codes.length,
            type: "advice",
            codes: JSON.stringify(codes),
          },
        });
        this.isAdd = false;
      }
      this.rowCodeIndex = index;
    },
    getSum(row) {
      let num = 0;
      row.codes.forEach((code) => {
        if (code.goodSum) {
          num += code.goodSum * 1;
        }
      });
      return num;
    },
    addColor() {
      this.formList.unshift(JSON.parse(JSON.stringify(this.formItem)));
    },
    checkForm() {
      let isError = false;
      for (let i = 0; i < this.formList.length; i++) {
        if (!this.formList[i].packMaterial) {
          isError = true;
        }
        if (this.formList[i].countryList.length === 0) {
          Toast("请至少添加一个颜色!");
          isError = true;
        }
        for (let j = 0; j < this.formList[i].countryList.length; j++) {
          if (this.formList[i].countryList[j].codes.length === 0) {
            Toast("请至少添加一个仓库!");
            isError = true;
          }
        }
      }
      // this.formList.forEach((item) => {
      //   if (!item.colorAsk || !item.countryId || item.codes.length == 0) {
      //     isError = true;
      //   }
      // });
      if (this.formList.length == 0) {
        Toast("请至少添加一个材质!");
        isError = true;
      }
      this.isError = isError;
      return isError;
    },
    getAllNumber(item) {
      let num = 0;
      item.codes.forEach((code) => {
        num += Number(code.goodSum);
      });
      return num;
    },
    handleDeleteColor(index1, index2) {
      this.formList[index1].countryList.splice(index2, 1);
    },
    handleDeleteOrder(index1) {
      this.formList.splice(index1, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  margin-top: 30px;

  .material-box {
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    padding: 30px 20px;
    border-radius: 22px;
    margin-top: 30px;
    position: relative;

    .icon-close {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #f56c6c;
      box-shadow: 0px 0px 10px 0px rgba(245, 108, 108, 0.6);
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(50%, -50%);
    }

    .top {
      .name {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 32px;
        color: #303133;
      }

      .button {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 28px;
        color: #3f996c;
        padding: 0;
      }
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    .color-box {
      position: relative;
      width: 100%;
      // height: 458px;
      background: #f7f7f7;
      border-radius: 22px;
      padding: 30px;
      box-sizing: border-box;

      .color-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .round {
          width: 12px;
          height: 12px;
          background: #3f996c;
          border-radius: 50%;
        }

        .text {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 32px;
          color: #303133;
        }

        .icon-tianjia {
          font-size: 34px;
          color: #3f996c;
        }
      }

      .item {
        padding: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .item-left {
          flex: 1;
          margin-right: 120px;

          .row {
            display: flex;
            justify-content: space-between;

            &:not(:last-child) {
              margin-bottom: 9px;
            }

            .line {
              display: flex;
              align-items: center;

              .label,
              .value {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 28px;
                color: #303133;
              }
            }
          }
        }

        .item-right {
          display: flex;
          align-items: center;
          justify-content: center;

          .iconfont {
            font-size: 17px;
            color: #b3b3b3;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
  .no-boder {
    border: none;
  }
  //   .color-box {
  //     width: 100%;
  //     background: #fff;
  //     box-sizing: border-box;
  //     padding: 0 20px;
  //     border-radius: 22px;
  //     position: relative;
  //     margin-top: 30px;
  //     // overflow: hidden;

  //     .close {
  //       position: absolute;
  //       right: -15px;
  //       top: -15px;
  //       width: 36px;
  //       height: 36px;
  //       font-size: 32px;
  //       display: flex;
  //       background: #f56c6c;
  //       box-sizing: border-box;
  //       align-items: center;
  //       justify-content: center;
  //       border-radius: 50%;

  //       // color: #fff;
  //       .icon-close {
  //         color: #fff;
  //         flex-shrink: 0;
  //       }
  //     }

  //     &.active {
  //       padding: 0;
  //     }

  //     &.textarea-box {
  //       padding: 20px 20px;
  //       text-align: left;
  //       font-size: 32px;

  //       .box-height {
  //         min-height: 200px;
  //       }

  //       &.error {
  //         border: 1px solid #f56c6c;
  //       }
  //     }

  //     .cell {
  //       .is-error {
  //         color: #f56c6c;
  //       }

  //       .choose {
  //         .icon-tianjia {
  //           font-size: 34px;
  //           color: #3f996c;
  //         }

  //         .color {
  //           color: #303133;
  //         }
  //       }
  //     }

  //     .no-boder {
  //       border: none;
  //     }

  //     .cell-code {
  //       display: flex;
  //       justify-content: space-between;
  //       font-size: 28px;
  //       height: 135px;
  //       box-sizing: border-box;
  //       align-items: center;
  //       border-bottom: 1px solid #dbdbdb;

  //       .icon-a-xialakaobei {
  //         color: #909399;
  //         margin-left: 5px;
  //         transform: rotate(90deg);
  //         transform-origin: center;
  //         display: inline-block;
  //         font-size: 16px;
  //         scale: 0.7;
  //       }

  //       .left {
  //         color: #303133;

  //         .top {
  //           display: flex;
  //           margin-bottom: 20px;
  //           column-gap: 120px;
  //         }

  //         .top,
  //         .bottom {
  //           text-align: left;
  //         }
  //       }
  //     }

  //     .fst-cell {
  //       margin-top: -30px;
  //     }
  //   }
}
</style>
